import { BaseModule } from "./base.module";
import { BootstrapNavigationBarModule } from "./bootstrap-navigation-bar.module";
import { DebounceModule } from "./debounce.module";
import { StateMachineModule } from "./state-machine.module";
import * as bootstrap from 'bootstrap';

export class StateMachineBasedBootstrapNavigationBarModule extends BootstrapNavigationBarModule {
	// TODO: when all is well, move everything to 1 module and remove unused methods from original base module

	actor = this.createActor(0);
	tick = 0;
	tickRate = 150;
	lag = 0;
	previousTime = Date.now();
	currentTime = Date.now();
	elapsedTime = 0;
	debugMode = false;
	stateMachineModule = new StateMachineModule();
	debounceModule = new DebounceModule();
	navContainer = document.querySelector('.main-navigation-container');
	mainNavigationContainerSelectorWithJumbotronAtTop = 'body.jumbotron-at-top .main-navigation-container';
	navBarMarginElementClass = '.navbar-margin-element';
	scrollTopNeutralClass = 'at-top';
	scrollTopPositiveClass = 'not-at-top';
	scrollTopFixedClass = 'fixed-top';
	fixed = false;
	firstLoad = true;
	jumbotronState = 'initial';
	navbarIdentifier = '#navbar';
	boundLoop;

	isVisible = [
		'shown',
		'idle',
		'observe',
		'move',
		'moving',
		'moved',
		'scrolling',
	];

	constructor() {
		super();
		// console.log(`[${this.constructor.name}] constructing`);
	}

	getNavBarMarginElement() {
		this.navBarMarginElement = document.querySelector(this.navBarMarginElementClass); // get the first navbar
		return this.navBarMarginElement;
	}

	getMainNavigationContainer() {
		this.mainNavigationContainer = document.querySelector('.main-navigation-container');
		// console.log('getMainNavigationContainer', this.mainNavigationContainer);
		return this.mainNavigationContainer;
	}


	getMainNavigationContainerNavBar() {
		this.mainNavigationContainerNavBar = document.querySelector('.main-navigation-container-navbar');
		console.log('getMainNavigationContainerNavBar would return', this.mainNavigationContainerNavBar);
		return this.mainNavigationContainerNavBar;
	}

	getMainNavigationContainerBackButtons() {
		this.mainNavigationContainerBackButtons = document.querySelectorAll('.main-navigation-container-back-button');
		console.log('getMainNavigationContainerBackButtons would return', this.mainNavigationContainerBackButtons);
		return this.mainNavigationContainerBackButtons;
	}

	getNavWithJumbotronAtTop() {
		this.nav = document.querySelector(this.mainNavigationContainerSelectorWithJumbotronAtTop); // get the first navbar
		return this.nav;
	}

	initialize() {
		this.setEventListeners();

		if (window.location.hash.length > 1) {
			this.forceScrollToWindowHash();
		}

		// handle case where jumbotron is the first item of the page
		if (this.getNavWithJumbotronAtTop()) {
			this.handleViewPortResizing();
		}

		// handle main navigation container stuff
		if (this.getMainNavigationContainer()) {
			this.handleScrollTargets();

			this.handleLogoWebsite();
			this.handleResizeForMainNavigationContainer();
		}

	}

	setEventListeners() {
		let actors = [this.actor];

		// basics
		this.stateMachineModule.addEventListenerForStateMachine('tick', document.documentElement, actors, this);
		this.stateMachineModule.addEventListenerForStateMachine('scrolling', document.documentElement, actors, this);
		this.stateMachineModule.addEventListenerForStateMachine('mobile-nav-collapse-hidden', document.documentElement, actors, this);
		this.stateMachineModule.addEventListenerForStateMachine('mobile-nav-collapse-show', document.documentElement, actors, this);
		this.stateMachineModule.addEventListenerForStateMachine('viewport-width-resizing', document.documentElement, actors, this);
		this.stateMachineModule.addEventListenerForStateMachine('notification-closed', document.documentElement, actors, this);

		// // megamenu related
		// this.stateMachineModule.addEventListenerForStateMachine('header-nav-collapse-show', document.documentElement, actors, this);
		// this.stateMachineModule.addEventListenerForStateMachine('header-nav-collapse-shown', document.documentElement, actors, this);
		// this.stateMachineModule.addEventListenerForStateMachine('header-nav-collapse-hidden', document.documentElement, actors, this);

		// const headerNavCollapses = document.querySelectorAll('.header-nav-collapse');
		// headerNavCollapses.forEach((headerNavCollapse) => {
		// 	if (headerNavCollapse) {
		// 		headerNavCollapse.addEventListener('shown.bs.dropdown', (event) => {
		// 			console.log('header nav collapse: shown');
		// 			this.triggerEventOnElement('header-nav-collapse-shown', document.documentElement);
		// 		});
		// 		headerNavCollapse.addEventListener('show.bs.dropdown', (event) => {
		// 			console.log('header nav collapse: show');
		// 			this.triggerEventOnElement('header-nav-collapse-show', document.documentElement);
		// 		});
		// 		headerNavCollapse.addEventListener('hidden.bs.dropdown', (event) => {
		// 			console.log('header nav collapse: hidden');
		// 			this.triggerEventOnElement('header-nav-collapse-hidden', document.documentElement);
		// 		});
		// 	}
		// });

		// back-button
		// this.stateMachineModule.addEventListenerForStateMachine('header-nav-collapse-back', document.documentElement, actors, this);

		const navbar = document.querySelector(this.navbarIdentifier);
		if (navbar) {
			navbar.addEventListener('show.bs.collapse', (event) => {
				this.triggerEventOnElement('mobile-nav-collapse-show', document.documentElement);
			});
			navbar.addEventListener('hidden.bs.collapse', (event) => {
				this.navContainerActivated = false;
				this.triggerEventOnElement('mobile-nav-collapse-hidden', document.documentElement);
			})
		}

		let backButtons = this.getMainNavigationContainerBackButtons();
		if (backButtons) {
			backButtons.forEach((backButton) => {
				// 
				backButton.addEventListener('click', (event) => {
					event.preventDefault(); // it would be a href anchor so prevent page navigation action
					console.log('backButton click event happened:', event);
					// would go back to initial state
					this.triggerEventOnElement('header-nav-collapse-back', document.documentElement);
				});
			});
		}

		// window.addEventListener('load', (event) => {
		this.handleWindowLoad();
		// });

	}

	hideMainNavigationContainerNavBar() {
		console.log('hideMainNavigationContainerNavBar');
		let navBar = this.getMainNavigationContainerNavBar();
		if (navBar) {
			navBar.classList.remove('show-on-smol');
			navBar.classList.add('hide-on-smol');
		}
	}

	showMainNavigationContainerNavBar() {
		console.log('showMainNavigationContainerNavBar');
		let navBar = this.getMainNavigationContainerNavBar();
		if (navBar) {
			navBar.classList.remove('show-on-smol');
			navBar.classList.remove('hide-on-smol');
		}
		if (navBar) {
			navBar.classList.add('show-on-smol');
			navBar.classList.remove('hide-on-smol');
		}
	}

	handleWindowLoad() {
		let actors = [this.actor];
		this.stateMachineModule.setInitializedState(actors, this);
		if (typeof window !== 'undefined') {
			// The DOM was parsed, and the svg sprites MUST
			// come before other elements in the DOM
			this.startLoop();
		}
		// window.addEventListener('hashchange', (event) => {
		// 	console.info('hashchange event', event);
		// 	this.onHashChange(event);
		// });
	}

	startLoop() {
		console.log('startLoop');
		if (this.tick === 0) {
			this.doRender();
		}
		this.boundLoop = this.loop.bind(this);
		requestAnimationFrame(this.boundLoop);
	}

	async loop() {


		this.currentTime = Date.now();
		this.elapsedTime = this.currentTime - this.previousTime;
		this.previousTime = this.currentTime;
		this.lag += this.elapsedTime;
		this.tick += 1;

		if (this.debugMode === true) {
			console.log('currentTime is at', this.currentTime);
			console.log('previousTime is at', this.previousTime);
			console.log('elapsedTime is at', this.elapsedTime);
			console.log('lag is at', this.lag);
		}

		if (this.lag >= this.tickRate) {
			this.doUpdate();
			this.doRender();
			this.lag -= this.tickRate;
		}
		requestAnimationFrame((frame) => {
			this.loop();
		});
	}

	doRender() {
		// this.navContainer.dataset.currentState = this.actor.currentState;

		let v = this.isVisible.filter((v) => {
			if (this.actor.currentState == v) {
				return true; // if the current state is one associated with visibility, then keep it in the filtered result
			}
			return false; // default
		});
		if (v.length > 0) {
			if (
				this.navContainer &&
				typeof this.navContainer !== 'undefined' &&
				typeof this.navContainer.dataset !== 'undefined'
			) {
				this.navContainer.dataset.isVisible = true;
			}
		} else {
			if (v.length === 0) {
				if (
					this.navContainer &&
					typeof this.navContainer !== 'undefined' &&
					typeof this.navContainer.dataset !== 'undefined'
				) {
					this.navContainer.dataset.isVisible = false;
				}
			}
		}
	}

	doUpdate() {
		this.stateMachineModule.triggerEventOnElement('tick', document.documentElement);
	}

	handleObserveInitial() {
		let logoWebsite = document.querySelector('.logo-website');
		let logoWebsiteFixed = document.querySelector('.logo-fixed-website');
		if (logoWebsite) {
			this.logoWebsiteHeight = logoWebsite.getBoundingClientRect().height;
			// console.log('logoWebsiteHeight', this.logoWebsiteHeight);
		}
		if (logoWebsiteFixed) {
			this.logoWebsiteFixedHeight = logoWebsiteFixed.getBoundingClientRect().height;
			// console.log('logoWebsiteFixedHeight', this.logoWebsiteFixedHeight);
		}

		if (logoWebsite && logoWebsiteFixed) {
			this.hasMultipleWebsiteLogos = true;
		}

		this.cacheHighestHeight();

		console.log('cachedHighestHeight', this.cachedHighestHeight);
	}

	cacheHighestHeight() {
		if (this.mainNavigationContainer) {
			this.cachedHighestHeight = this.mainNavigationContainer.getBoundingClientRect().height;
		}
	}

	/**
	 * 
	 * @param {Number} id 
	 * @returns 
	 */
	createActor(id) {
		return {
			id: id,
			role: 'actor',
			initialState: 'initialized',
			currentState: 'initialized',
			nextStates: [],
			states: {
				// if the state of the state machine is 'idle', define an object with states that can transition from the current state
				// if one is found it can be called, containing a next function returning a reduced state that can be the same as the current or the next.
				// If not, a state is not changed, so less unexpected behavior occurs than in a bottom-up approach
				// where more checks must occur for missing data
				'initialized': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'observe-initial';
								// console.log('was initialized, tick happened, next state will be', nextState);
								return nextState;
							}
						},
					},
				},
				'observe-initial': {
					on: {
						'tick': {
							next: (...args) => {
								console.info('[observe-initial] > (tick)');

								this.handleObserveInitial();
								let nextState = 'move-initial';
								// console.log('was observe-initial, tick happened, next state will be', nextState);

								return nextState;
							}
						},
					},
				},

				'move-initial': {
					on: {
						'tick': {
							next: (...args) => {
								this.move();
								let nextState = 'showing';
								// console.log('was move-initial, tick happened, next state will be', nextState);
								return nextState;
							}
						},
						'viewport-width-resizing': {
							next: (...args) => {
								this.move();
								let nextState = 'hidden';
								console.log('was move-initial, viewport-width-resizing happened, next state will be', nextState);
								return nextState;
							}
						},
						'scrolling': {
							next: (...args) => {
								this.move();
								let nextState = 'hidden';
								console.log('was move-initial, scrolling happened, next state will be', nextState);
								return nextState;
							}
						},
					},
				},
				'showing': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'shown';
								// console.log('was showing, tick happened, next state will be', nextState);
								return nextState;
							}
						},
						'viewport-width-resizing': {
							next: (...args) => {
								this.move();
								let nextState = 'hidden';
								console.log('was showing, viewport-width-resizing happened, next state will be', nextState);
								return nextState;
							}
						},
						'scrolling': {
							next: (...args) => {
								this.move();
								let nextState = 'hidden';
								console.log('was showing, scrolling happened, next state will be', nextState);
								return nextState;
							}
						},
					},
				},
				'shown': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'observe';
								// console.log('was shown, tick happened, next state will be', nextState);
								return nextState;
							}
						},
					},
				},
				'observe': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'move';
								// this.handleObserve();
								this.cacheHighestHeight();
								if (this.getMainNavigationContainer()) {
									// console.info('main navigation container detected');
									this.handleScrollTargets();
								}
								this.emitHeight();
								// console.log('was observe, tick happened, next state will be', nextState);
								return nextState;
							}
						},
						'notification-closed': {
							next: (...args) => {
								let nextState = 'observe-initial';
								// this.handleObserve();
								// console.log('was observe, notification-closed happened, next state will be', nextState);
								return nextState;
							}
						},
						'mobile-nav-collapse-hidden': {
							next: (...args) => {
								let nextState = 'observe';
								const navbar = document.getElementById('navbar');
								if (navbar) {
									this.handleCollapseHide();
									this.handleCollapseHidden();
								}
								console.log('was observe, mobile-nav-collapse-hidden happened, next state will be', nextState);
								return nextState;
							}
						},
						'mobile-nav-collapse-show': {
							next: (...args) => {
								let nextState = 'observe';
								this.handleCollapseShow();
								// console.log('was observe, mobile-nav-collapse-shown happened, next state will be', nextState);
								return nextState;
							}
						},
						'scrolling': {
							next: (...args) => {
								let nextState = 'move';
								// console.log('was observe, scrolling happened, next state will be', nextState);
								return nextState;
							}
						},
						'viewport-width-resizing': {
							next: (...args) => {
								let nextState = 'hidden';
								// observe the scrolling!
								// console.log('was observe, viewport-width-resizing happened, next state will be', nextState);
								return nextState;
							}
						},
						// 'header-nav-collapse-show': {
						// 	next: (...args) => {
						// 		let nextState = 'observe';
						// 		this.hideMainNavigationContainerNavBar();
						// 		return nextState;
						// 	}
						// },
						// 'header-nav-collapse-shown': {
						// 	next: (...args) => {
						// 		this.jumbotronState = 'opened-secondary-nav';
						// 		let nextState = 'observe';
						// 		return nextState;
						// 	}
						// },
						// 'header-nav-collapse-hidden': {
						// 	next: (...args) => {
						// 		let nextState = 'observe';
						// 		this.jumbotronState = 'initial';
						// 		this.showMainNavigationContainerNavBar();
						// 		return nextState;
						// 	}
						// },
						// 'header-nav-collapse-back': {
						// 	next: (...args) => {
						// 		let nextState = 'observe';
						// 		this.handleHeaderNavCollapseBack();
						// 		return nextState;
						// 	}
						// },
					},
				},
				'hidden': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'observe-initial';
								// console.log('was hidden, tick happened, next state will be', nextState);

								return nextState;
							}
						},
						'viewport-width-resizing': {
							next: (...args) => {
								let nextState = 'hidden';
								// observe the scrolling!
								console.log('was hidden, viewport-width-resizing happened, next state will be', nextState);
								return nextState;
							}
						},
					},
				},
				'move': {
					on: {
						'notification-closed': {
							next: (...args) => {
								let nextState = 'observe-initial';
								// console.log('was move, notification-closed happened, next state will be', nextState);
								return nextState;
							}
						},
						'tick': {
							next: (...args) => {

								this.move();

								let nextState = 'observe';
								// console.log('was move, tick happened, next state will be', nextState);
								return nextState;
							}
						},
						'mobile-nav-collapse-show': {
							next: (...args) => {
								let nextState = 'observe';
								this.handleCollapseShow();
								return nextState;
							}
						},
						'mobile-nav-collapse-hidden': {
							next: (...args) => {
								let nextState = 'observe';
								this.handleCollapseHide();
								this.handleCollapseHidden();
								console.log('was move, mobile-nav-collapse-hidden happened, next state will be', nextState);
								return nextState;
							}
						},
						// 'header-nav-collapse-show': {
						// 	next: (...args) => {
						// 		let nextState = 'observe';
						// 		this.hideMainNavigationContainerNavBar();
						// 		return nextState;
						// 	}
						// },
						// 'header-nav-collapse-shown': {
						// 	next: (...args) => {
						// 		this.jumbotronState = 'opened-secondary-nav';
						// 		this.move();
						// 		let nextState = 'observe';
						// 		return nextState;
						// 	}
						// },
						// 'header-nav-collapse-hidden': {
						// 	next: (...args) => {
						// 		let nextState = 'observe';
						// 		this.move();
						// 		this.jumbotronState = 'initial';
						// 		this.showMainNavigationContainerNavBar();
						// 		return nextState;
						// 	}
						// },
						// 'header-nav-collapse-back': {
						// 	next: (...args) => {
						// 		let nextState = 'observe';
						// 		this.handleHeaderNavCollapseBack();
						// 		return nextState;
						// 	}
						// },
						'viewport-width-resizing': {
							next: (...args) => {
								let nextState = 'observe-initial';
								// observe the scrolling!
								// console.log('was move, viewport-width-resizing happened, next state will be', nextState);
								return nextState;
							}
						},
					},
				}
			}
		}
	}

	handleHeaderNavCollapseBack() {
		console.log('header-nav-collapse-back', 'handleHeaderNavCollapseBack');
		this.showMainNavigationContainerNavBar();
		new bootstrap.Dropdown(this.navbarIdentifier, {
			show: true
		});
	}

	move() {
		let height = this.cachedHighestHeight;
		let element = document.querySelector(
			'.jumbotron-fixed .jumbotron-text-column'
		);

		if (element && element.style) {
			element.style.marginTop = `${height}px`;
		}

		// only get the first found!
		let element2 = document.querySelector(
			// only select it if it is the first item!
			`header+.jumbotron-fixed, header+main .jumbotron-fixed, header+.svg-icon+main .jumbotron-fixed`
		);
		if (element2 && element2.style) {
			element2.style.marginTop = `-${height}px`;
			if (this.getMainNavigationContainer().classList.contains(this.scrollTopNeutralClass)) {
				if (this.jumbotronState == 'opened-secondary-nav') {
					element2.style.transition = 'margin-top 0.2s';
				} else {
					if (this.jumbotronState == 'initial') {
						element2.style.transition = 'none';
					}
				}
			} else {
				element2.style.transition = 'none';
			}
		}
		if (document.documentElement.scrollTop === 0) {
			if (this.getMainNavigationContainer()) {
				this.getMainNavigationContainer().classList.add(this.scrollTopNeutralClass);
				if (this.fixed === false) {
					this.getMainNavigationContainer().classList.remove(this.scrollTopPositiveClass);
					// this.getMainNavigationContainer().classList.remove(this.scrollTopFixedClass);
				}
			}
		}
		if (document.documentElement.scrollTop > 0) {
			if (this.getMainNavigationContainer()) {
				this.getMainNavigationContainer().classList.add(this.scrollTopPositiveClass);
				this.getMainNavigationContainer().classList.remove(this.scrollTopNeutralClass);
			}
		}
	}

	handleViewPortResizing() {
		this.removeScrollClasses();
	}

	removeScrollClasses() {
		this.getMainNavigationContainer().classList.remove(this.scrollTopNeutralClass);
		this.getMainNavigationContainer().classList.remove(this.scrollTopPositiveClass);
		this.getMainNavigationContainer().classList.remove(this.scrollTopFixedClass);
	}

	handleCollapseHide() {
		// get the first container
		if (this.navContainer) {
			this.navContainer.classList.remove('activated');
			// this.cachedHeight = this.cachedCollapseHeight;
			// this.cachedHighestHeight = this.cachedCollapseHeight;
			this.getNavBarMarginElement().style.maxHeight = `0px`;
		}
	}

	handleCollapseShow() {
		// get the first container
		this.cachedCollapseHeight = this.cachedHeight;
		if (this.navContainer) {
			this.navContainer.classList.add('activated');
			this.navContainerActivated = true;
		}
	}

	handleCollapseHidden() {
		if (this.navContainer) {
			this.navContainer.classList.remove('activated');
			this.navContainerActivated = false;
		}
	}

}